import React from "react";
import { Route, Redirect } from "react-router-dom";
import PrivateLayout from "layouts/PrivateLayout.jsx";
import _authService from "modules/AuthService.js";
import NetworkDetector from "../HOC/NetworkDetector";

const PrivateRoute = ({ component: Component, layout: Layout, role: role, menuId: menuId, ...rest }) => (
  <Route {...rest} render={props => (
    //Also check role
    _authService.isAuthenticated()
      ?
      <PrivateLayout componentName={menuId}>
        <Component {...props} />
      </PrivateLayout>
      :
      <Redirect to={{
        pathname: '/'
      }} />
  )} />

  // <Route {...rest} render={props => (
  //     <PrivateLayout>
  //       <Component {...props} />
  //     </PrivateLayout>
  //   )} />
)

export default NetworkDetector(PrivateRoute)